<template>
    <el-drawer
        custom-class="custom-drawer"
        :visible.sync="drawerVisible"
        :close-on-press-escape="false"
        :wrapper-closable="false"
        :show-close="false"
        size="600px"
    >
        <template slot="title">
            <div class="custom-title">
                <div class="title-name">{{ order && order.qu_time ? '已取车信息' : '取车操作' }}</div>
                <i class="el-icon-circle-close close-btn pointer" @click="closeDrawer" />
            </div>
        </template>
        <div class="custom-content">
            <el-form ref="qucheForm" :model="qucheData" label-width="120px">
                <el-form-item label="取车时间" prop="qu_time">
                    <el-date-picker
                        v-model="qucheData.qu_time"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        format="yyyy-MM-dd HH:mm:ss"
                        placeholder="请选择取车时间"
                        style="width: 100%;"
                    />
                </el-form-item>
                <el-form-item label="车辆照片" prop="qu_car_thumbarr">
                    <image-upload
                        :key="`cheliang_${uploadRenderKey}`"
                        ref="cheliangUpload"
                        :tipInfo="`上传车辆照片，格式为'jpg','jpeg','png','gif'，大小不超过2M`"
                        :image-list="cheliangDefaultList"
                        :maxNumber="5"
                        @updateImg="onUpdateCheliangImg"
                    />
                </el-form-item>
                <el-form-item label="交接协议" prop="qu_car_jiaojie_thumb">
                    <image-upload
                        :key="`jiaojie_${uploadRenderKey}`"
                        ref="jiaojieUpload"
                        :tipInfo="`上传交接协议照片，格式为'jpg','jpeg','png','gif'，大小不超过2M`"
                        :image-list="jiaojieDefaultList"
                        :maxNumber="3"
                        @updateImg="onUpdateJiaojieImg"
                    />
                </el-form-item>
                <!-- 交管12123备案照片 - 已隐藏
                <el-form-item label="交管12123备案照片" prop="qu_bang_12123">
                    <image-upload
                        :key="`xingshi_${uploadRenderKey}`"
                        ref="xingshiUpload"
                        :tipInfo="`上传交管12123备案照片，格式为'jpg','jpeg','png','gif'，大小不超过2M`"
                        :image-list="xingshiDefaultList"
                        :maxNumber="2"
                        @updateImg="onUpdateXingshiImg"
                    />
                </el-form-item>
                -->
                <el-form-item label="备注" prop="qu_remark">
                    <el-input
                        v-model="qucheData.qu_remark"
                        type="textarea"
                        :rows="3"
                        placeholder="请输入备注"
                    />
                </el-form-item>
            </el-form>
            <div class="fix-fotter">
                <el-button
                    style="min-width: 117px; background: #1067E0; font-size: 16px; border-color: #1067E0;"
                    size="mini"
                    type="primary"
                    @click="submitQuche"
                >
                    提交
                </el-button>
            </div>
        </div>
    </el-drawer>
</template>

<script>
import { postquche } from "@/api/tianzheng/zucheorder";
import ImageUpload from "@/components/Upload/image";

export default {
    name: "QucheInfo",
    components: {
        ImageUpload,
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        order: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            qucheData: {
                id: 0,
                qu_time: '',
                qu_car_thumbarr: [],
                qu_car_jiaojie_thumb: [],
                qu_bang_12123: [],
                qu_remark: '',
            },
            cheliangDefaultList: '',
            jiaojieDefaultList: '',
            xingshiDefaultList: '',
            uploadRenderKey: 0,
        };
    },
    computed: {
        drawerVisible: {
            get() {
                return this.visible;
            },
            set(val) {
                this.$emit("update:visible", val);
            },
        },
    },
    watch: {
        visible(val) {
            if (val) {
                this.initFromOrder(this.order);
            } else {
                this.resetForm();
            }
        },
        order: {
            deep: true,
            handler(val) {
                if (this.visible) {
                    this.initFromOrder(val);
                }
            },
        },
    },
    methods: {
        getCurrentDateTimeString() {
            const date = new Date();
            const pad = (num) => String(num).padStart(2, '0');
            const year = date.getFullYear();
            const month = pad(date.getMonth() + 1);
            const day = pad(date.getDate());
            const hour = pad(date.getHours());
            const minute = pad(date.getMinutes());
            const second = pad(date.getSeconds());
            return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
        },
        parseImgArray(value) {
            if (!value) return [];
            if (Array.isArray(value)) {
                return value.map(item => {
                    if (typeof item === 'string') return item;
                    return item.path || item.url || '';
                }).filter(Boolean);
            }
            if (typeof value === 'string') {
                const trimmed = value.trim();
                if (!trimmed) return [];
                try {
                    const parsed = JSON.parse(trimmed);
                    if (Array.isArray(parsed)) {
                        return parsed.map(item => {
                            if (typeof item === 'string') return item;
                            return item.path || item.url || '';
                        }).filter(Boolean);
                    }
                } catch (error) {
                    // 非JSON字符串，按逗号分隔兼容历史数据
                }
                return trimmed.split(',').map(item => item.trim()).filter(Boolean);
            }
            return [];
        },
        toAbsoluteImgUrl(path) {
            if (!path) return '';
            if (/^https?:\/\//.test(path)) return path;
            const baseUrl = (this.$publicData && this.$publicData.imgUrl) || '';
            return `${baseUrl}${path}`;
        },
        buildUploadDefaultList(pathArr) {
            if (!Array.isArray(pathArr) || pathArr.length === 0) return '';
            return JSON.stringify(pathArr.map((path, index) => ({
                name: `img_${index + 1}`,
                path,
                url: this.toAbsoluteImgUrl(path),
            })));
        },
        extractUploadPaths(val) {
            if (!Array.isArray(val)) return [];
            return val.map(item => {
                if (item.path) return item.path;
                if (item.response && item.response.result && item.response.result.url) {
                    return item.response.result.url;
                }
                return item.url || '';
            }).filter(Boolean);
        },
        initFromOrder(order) {
            if (!order) {
                this.resetForm();
                return;
            }
            this.clearUploadCache();
            const carThumbArr = this.parseImgArray(order.qu_car_thumbarr);
            const jiaojieThumbArr = this.parseImgArray(order.qu_car_jiaojie_thumb);
            const xingshizhengArr = this.parseImgArray(order.qu_bang_12123);

            this.qucheData = {
                id: order.id || 0,
                qu_time: order.qu_time || this.getCurrentDateTimeString(),
                qu_car_thumbarr: carThumbArr,
                qu_car_jiaojie_thumb: jiaojieThumbArr,
                qu_bang_12123: xingshizhengArr,
                qu_remark: order.qu_remark || '',
            };

            this.cheliangDefaultList = '';
            this.jiaojieDefaultList = '';
            this.xingshiDefaultList = '';

            // 抽屉首次打开时，等待上传组件挂载后再回显
            this.$nextTick(() => {
                this.cheliangDefaultList = this.buildUploadDefaultList(carThumbArr);
                this.jiaojieDefaultList = this.buildUploadDefaultList(jiaojieThumbArr);
                this.xingshiDefaultList = this.buildUploadDefaultList(xingshizhengArr);
            });
        },
        resetForm() {
            this.clearUploadCache();
            this.qucheData = {
                id: 0,
                qu_time: this.getCurrentDateTimeString(),
                qu_car_thumbarr: [],
                qu_car_jiaojie_thumb: [],
                qu_bang_12123: [],
                qu_remark: '',
            };
            this.cheliangDefaultList = '';
            this.jiaojieDefaultList = '';
            this.xingshiDefaultList = '';
        },
        clearUploadCache() {
            const refs = ['cheliangUpload', 'jiaojieUpload', 'xingshiUpload'];
            refs.forEach((name) => {
                const comp = this.$refs[name];
                if (comp && typeof comp.clearFileList === 'function') {
                    comp.clearFileList();
                }
            });
            this.uploadRenderKey += 1;
        },
        closeDrawer() {
            this.drawerVisible = false;
            this.resetForm();
            this.$emit("closed");
        },
        onUpdateCheliangImg(val) {
            this.qucheData.qu_car_thumbarr = this.extractUploadPaths(val);
        },
        onUpdateJiaojieImg(val) {
            this.qucheData.qu_car_jiaojie_thumb = this.extractUploadPaths(val);
        },
        onUpdateXingshiImg(val) {
            this.qucheData.qu_bang_12123 = this.extractUploadPaths(val);
        },
        submitQuche() {
            if (!this.order || !this.order.id) {
                this.$message.warning('订单信息不存在，请刷新后重试');
                return;
            }
            if (this.qucheData.qu_car_thumbarr.length === 0) {
                this.$message.warning('请上传车辆照片');
                return;
            }
            if (this.qucheData.qu_car_jiaojie_thumb.length === 0) {
                this.$message.warning('请上传交接协议');
                return;
            }
            // 交管12123备案照片 - 已隐藏
            // if (this.qucheData.qu_bang_12123.length === 0) {
            //     this.$message.warning('请上传交管12123备案照片');
            //     return;
            // }

            // const totalImgCount = this.qucheData.qu_car_thumbarr.length + this.qucheData.qu_car_jiaojie_thumb.length + this.qucheData.qu_bang_12123.length;
            // if (totalImgCount > 10) {
            //     this.$message.warning('取车图片总数不能超过10张');
            //     return;
            // }

            const params = {
                id: this.order.id,
                qu_time: this.qucheData.qu_time || this.getCurrentDateTimeString(),
                qu_car_thumbarr: this.qucheData.qu_car_thumbarr,
                qu_car_jiaojie_thumb: this.qucheData.qu_car_jiaojie_thumb,
                // qu_bang_12123: this.qucheData.qu_bang_12123,
                qu_remark: this.qucheData.qu_remark,
            };

            postquche(params).then((res) => {
                if (res.code == 200) {
                    this.$message.success('取车信息提交成功');
                    this.drawerVisible = false;
                    this.$emit("success");
                    this.$emit("closed");
                    this.resetForm();
                } else {
                    this.$message.error(res.message);
                }
            });
        },
    },
};
</script>
